import {FC} from 'react';
import {UiLongTask} from 'types/long-task';

import Progress, {useProgressBar} from '../../Loaders/Progress';

type LongTaskProgressBarProps = {
    longTask: UiLongTask | undefined;
};

const LongTaskProgress: FC<LongTaskProgressBarProps> = ({longTask}) => {
    const hasErrors = longTask ? longTask?.errors.length > 0 : false;

    const progressRef = useProgressBar(
        longTask?.currentProgress,
        longTask?.maxProgress,
    );
    return (
        <Progress
            ref={progressRef}
            state={hasErrors ? 'failure' : 'inProgress'}
        />
    );
};

export default LongTaskProgress;
